<div class="row-wrapper">
  <div nz-row>
    <div nz-col [nzXs]="newAccount.labelW.xs" [nzSm]="newAccount.labelW.sm"></div>
    <div nz-col [nzXs]="newAccount.inputW.xs" [nzSm]="newAccount.inputW.sm" [nzXl]="newAccount.inputW.xl">
      <div class="graphic-dot"></div>
      <div class="form-title">{{ 'NEW_ACCOUNT.REGISTER_MYSELF' | translate }}</div>
    </div>
  </div>
</div>

<nz-spin
  class="mobiapp-spin login-spin"
  [nzTip]="'COMMON.GENERAL.LOADING_APPLICATION_DATA' | translate"
  nzSize="large"
  [nzSpinning]="newAccount.actionLoading$ | async"
  [nzIndicator]="LoadingIndicator">
  <form nz-form [formGroup]="newAccount.newAccountForm" class="row-wrapper">
    <nz-form-item>
      <nz-form-label [nzXs]="newAccount.labelW.xs" [nzSm]="newAccount.labelW.sm" nzRequired nzFor="name">
        {{ 'COMMON.LABEL.FIRST_NAME' | translate }}
      </nz-form-label>
      <nz-form-control
        [nzXs]="newAccount.inputW.xs"
        [nzSm]="newAccount.inputW.sm"
        [nzXl]="newAccount.inputW.xl"
        [nzErrorTip]="errorTpl"
        aria-live="assertive"
        nzHasFeedback>
        <input
          nz-input
          required
          id="name"
          type="text"
          formControlName="name"
          autocomplete="given-name"
          (focus)="newAccount.scrollToInput($event)"
          [attr.aria-invalid]="
            newAccount.newAccountForm.controls.name.invalid && newAccount.newAccountForm.controls.name.touched
              ? 'true'
              : null
          " />
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label [nzXs]="newAccount.labelW.xs" [nzSm]="newAccount.labelW.sm" nzRequired nzFor="surname">
        {{ 'COMMON.LABEL.SURNAME' | translate }}
      </nz-form-label>
      <nz-form-control
        [nzXs]="newAccount.inputW.xs"
        [nzSm]="newAccount.inputW.sm"
        [nzXl]="newAccount.inputW.xl"
        [nzErrorTip]="errorTpl"
        aria-live="assertive"
        nzHasFeedback>
        <input
          nz-input
          required
          id="surname"
          type="text"
          formControlName="surname"
          autocomplete="family-name"
          (focus)="newAccount.scrollToInput($event)"
          [attr.aria-invalid]="
            newAccount.newAccountForm.controls.surname.invalid && newAccount.newAccountForm.controls.surname.touched
              ? 'true'
              : null
          " />
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label [nzXs]="newAccount.labelW.xs" [nzSm]="newAccount.labelW.sm" nzRequired nzFor="email">
        {{ 'COMMON.LABEL.EMAIL' | translate }}
      </nz-form-label>
      <nz-form-control
        [nzXs]="newAccount.inputW.xs"
        [nzSm]="newAccount.inputW.sm"
        [nzXl]="newAccount.inputW.xl"
        [nzErrorTip]="errorTpl"
        aria-live="assertive"
        nzHasFeedback>
        <input
          nz-input
          required
          id="email"
          type="email"
          formControlName="email"
          autocomplete="email"
          (focus)="newAccount.scrollToInput($event)"
          [attr.aria-invalid]="
            newAccount.newAccountForm.controls.email.invalid && newAccount.newAccountForm.controls.email.touched
              ? 'true'
              : null
          " />
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label [nzXs]="newAccount.labelW.xs" [nzSm]="newAccount.labelW.sm" nzRequired nzFor="confirmEmail">
        {{ 'COMMON.LABEL.CONFIRM_EMAIL' | translate }}
      </nz-form-label>
      <nz-form-control
        [nzXs]="newAccount.inputW.xs"
        [nzSm]="newAccount.inputW.sm"
        [nzXl]="newAccount.inputW.xl"
        [nzErrorTip]="errorTpl"
        aria-live="assertive"
        nzHasFeedback>
        <input
          nz-input
          required
          id="confirmEmail"
          type="email"
          autocomplete="false"
          formControlName="confirmEmail"
          (focus)="newAccount.scrollToInput($event)"
          [attr.aria-invalid]="
            newAccount.newAccountForm.controls.confirmEmail.invalid &&
            newAccount.newAccountForm.controls.confirmEmail.touched
              ? 'true'
              : null
          " />
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label [nzXs]="newAccount.labelW.xs" [nzSm]="newAccount.labelW.sm" nzRequired nzFor="telephoneNumber">
        {{ 'COMMON.LABEL.PHONE_NUMBER' | translate }}
      </nz-form-label>
      <nz-form-control
        [nzXs]="newAccount.inputW.xs"
        [nzSm]="newAccount.inputW.sm"
        [nzXl]="newAccount.inputW.xl"
        [nzErrorTip]="errorTpl"
        aria-live="assertive"
        nzHasFeedback>
        <app-phone-input inputId="telephoneNumber" formControlName="telephoneNumber" mode="manual-calling-code">
        </app-phone-input>
      </nz-form-control>
    </nz-form-item>

    <nz-form-item class="terms-form-item">
      <nz-form-label [nzNoColon]="true" [nzXs]="newAccount.labelW.xs" [nzSm]="newAccount.labelW.sm"></nz-form-label>
      <nz-form-control
        class="terms-checkbox-control"
        [nzXs]="newAccount.inputW.xs"
        [nzSm]="newAccount.inputW.sm"
        [nzXl]="newAccount.inputW.xl">
        <label nz-checkbox formControlName="hasAcceptedGDPR" class="terms-checkbox-row">
          <span id="gdprLabel" class="terms-copy terms-text">
            {{ 'NEW_ACCOUNT.TOS_GDPR_ACCEPTANCE.STEP_1_CONFIRM' | translate }}
            <a [routerLink]="['/tos']">
              {{ 'NEW_ACCOUNT.TOS_GDPR_ACCEPTANCE.TOS' | translate }}
            </a>
            {{ 'NEW_ACCOUNT.TOS_GDPR_ACCEPTANCE.STEP_2_OR' | translate }}
            <a [routerLink]="['/privacy-policy']">
              {{ 'NEW_ACCOUNT.TOS_GDPR_ACCEPTANCE.PRIVACY_POLICY' | translate }}
            </a>
            {{ 'NEW_ACCOUNT.TOS_GDPR_ACCEPTANCE.STEP_3_ACCEPT' | translate }}
          </span>
        </label>
      </nz-form-control>
    </nz-form-item>

    <nz-form-item class="terms-form-item">
      <nz-form-label [nzNoColon]="true" [nzXs]="newAccount.labelW.xs" [nzSm]="newAccount.labelW.sm"></nz-form-label>
      <nz-form-control
        class="terms-checkbox-control"
        [nzXs]="newAccount.inputW.xs"
        [nzSm]="newAccount.inputW.sm"
        [nzXl]="newAccount.inputW.xl">
        <label nz-checkbox formControlName="hasAcceptedDataProcessing" class="terms-checkbox-row complex">
          <span id="dataProcessingLabel" class="terms-copy label-text">
            <span
              class="terms-copy-text"
              [innerHTML]="
                newAccount.termsAcceptanceShownFully
                  ? ('NEW_ACCOUNT.DATA_PROCESSING_ACCEPTANCE' | translate)
                  : ('NEW_ACCOUNT.DATA_PROCESSING_ACCEPTANCE_SHORT' | translate)
              ">
            </span>
            @if (!newAccount.termsAcceptanceShownFully) {
              <span class="terms-copy-ellipsis" aria-hidden="true">...</span>
            }
            @if (!newAccount.termsAcceptanceShownFully) {
              <button
                type="button"
                class="suffix-text"
                (click)="
                  $event.preventDefault(); $event.stopPropagation(); newAccount.termsAcceptanceShownFully = true
                ">
                {{ 'NEW_ACCOUNT.SHOW_FULL_ACCEPTANCE_CONTENT' | translate }}
              </button>
            }
          </span>
        </label>
      </nz-form-control>
    </nz-form-item>
  </form>

  @if (newAccount.newAccountForm.invalid && (newAccount.errorMessage$ | async); as errorMessage) {
    <div class="row-wrapper">
      <div nz-row>
        <div class="server-error-message" nz-col [nzSpan]="24">
          <p [innerHTML]="'COMMON.ERROR.' + errorMessage | translate: { email: newAccount.lastUsedData.email }"></p>
        </div>
      </div>
    </div>
  }

  <div class="row-wrapper">
    <div nz-row>
      <div nz-col [nzXs]="newAccount.labelW.xs" [nzSm]="newAccount.labelW.sm"></div>
      <div nz-col [nzXs]="24" [nzMd]="newAccount.inputW.sm" [nzXl]="newAccount.inputW.xl">
        <button
          (click)="newAccount.sendForm()"
          class="submit-button"
          [disabled]="
            newAccount.newAccountForm.pristine ||
            (newAccount.newAccountForm.dirty && newAccount.newAccountForm.invalid) ||
            (newAccount.actionLoading$ | async) ||
            (newAccount.errorMessage$ | async) === 'SELF_REGISTRATION_CURRENTLY_UNAVAILABLE'
          "
          mat-raised-button
          color="primary">
          {{ 'NEW_ACCOUNT.REGISTER_MYSELF' | translate }}
        </button>
      </div>
    </div>
    <div nz-row class="login-page-link-row">
      <div nz-col [nzXs]="newAccount.labelW.xs" [nzSm]="newAccount.labelW.sm"></div>
      <div nz-col [nzXs]="24" [nzSm]="newAccount.inputW.sm" [nzXl]="newAccount.inputW.xl">
        <a (click)="$event.preventDefault()" [routerLink]="['/login']">
          {{ 'NEW_ACCOUNT.I_HAVE_ACCOUNT_LOGIN' | translate }}
        </a>
      </div>
    </div>
  </div>
</nz-spin>
<ng-template #errorTpl let-control>
  @if (control.invalid) {
    {{ control.errors | errorsFormatingAndTranslate }}
  }
</ng-template>

<ng-template #LoadingIndicator>
  <span nz-icon nzType="loading" class="ant-spin-dot"></span>
</ng-template>
